/** Ügyfélszolgálat number — revealed ONLY after the „Hívás" pill is tapped
    (Phone_Show), dialed on the second tap (Phone_Call). Never rendered before. */
export const SUPPORT_PHONE_TEL = '+36306266000'
export const SUPPORT_PHONE_DISPLAY = '+36 30 626 6000'

export const PRIVACY_PDF_URL = '/akkumost_adatkezelesi_tajekoztato_20260807.pdf'

/* Entrance copy — the brief's opening statement (§3.1), restructured into the
   three promises it always was, so the landing scans instead of reading as a
   40-word block. Every clause is kept verbatim; the H1 above them is the
   keyword line and matches the <title> and the no-JS fallback in index.html. */
export const ENTRANCE_TITLE = 'Akkumulátor-csere a helyszínen, egy beszélgetéssel'

export const ENTRANCE_FRAME = 'Ez a beszélgetés ugyanaz, mintha az ügyfélszolgálatunkat hívná.'

export const ENTRANCE_PROMISES = [
	{ icon: 'battery', text: 'Megtaláljuk az autójához illő akkumulátort' },
	{ icon: 'calendar', text: 'Időpontot foglalunk' },
	{ icon: 'pin', text: 'Szerelőt küldünk oda, ahol az autója áll' },
] as const

/* Trust row — only claims the system can back: the price rule from the brief
   (§5 price card), the published opening hours + area from the index.html
   LocalBusiness schema, and the fitment guarantee (§5 battery card). */
export const ENTRANCE_TRUST = [
	'Kiszállás és beszerelés az árban',
	'Budapest, minden nap 8–24',
	'Gyári adatbázis alapján illesztjük',
]
